<template>
  <div
    :class="ns.b()"
    data-test-name="menu-toggle"
    data-test-variant=""
    data-test-state=""
  >
    <b-icon>
      <ChevronRight v-if="collapsed" />
      <ChevronLeft v-else />
    </b-icon>
  </div>
</template>

<script lang="ts" setup>
import { ChevronLeft, ChevronRight } from '@bigin/icons-vue'
import BIcon from '@bigin/components/icon'
import { useNamespace } from '@bigin/hooks'
import { menuToggleProps } from './menu-toggle'

defineOptions({ name: 'BMenuToggle' })
defineProps(menuToggleProps)

const ns = useNamespace('menu-toggle')
</script>
